const fitzgeraldColors = {
  person: "#DD8800",
  verb: "#229900",
  adjective: "#0088CC",
  expression: "#CC00BB",
  not: "#333333",
};

export default fitzgeraldColors;
